module.exports = __webpack_public_path__ + "static/media/accessories.5c9d57b0.webp";